module.exports = __webpack_public_path__ + "static/media/sign-in-background.4b771074.png";